import { Injectable } from "@angular/core";

export interface BrowserLocation {
    latitude: number;
    longitude: number;
    accuracyMeters: number;
    capturedAt: string;
    source: 'BrowserGps';
}

@Injectable({
    providedIn: 'root'
})
export class GeolocationService {
    async getPermissionState(): Promise<PermissionState | null> {
        if (!navigator.permissions) {
            return null;
        }

        const status = await navigator.permissions.query({
            name: 'geolocation' as PermissionName
        });

        return status.state; // granted | prompt | denied
    }

    async getCurrentLocationWithoutPrompt(): Promise<BrowserLocation | null> {
        const permission = await this.getPermissionState();

        if (permission !== 'granted') {
            return null;
        }

        return this.getCurrentLocation();
    }

    async getCurrentLocation(): Promise<BrowserLocation | null> {
        if (!navigator.geolocation) {
            return null;
        }

        return new Promise(resolve => {
            navigator.geolocation.getCurrentPosition(
                position => {
                    resolve({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        accuracyMeters: position.coords.accuracy,
                        capturedAt: new Date().toISOString(),
                        source: 'BrowserGps'
                    });
                },
                () => resolve(null),
                {
                    enableHighAccuracy: true,
                    timeout: 8000,
                    maximumAge: 60000
                }
            );
        });
    }
}